export const env = {
  REACT_APP_APIKEY: 'AIzaSyDsbZ_jdH921OQp3xs6VaWxrYWOAqp40pU',
  REACT_APP_AUTHDOMAIN: 'aldg-procore.firebaseapp.com',
  REACT_APP_PROJECTID: 'aldg-procore',
  REACT_APP_STORAGEBUCKET: 'aldg-procore.appspot.com',
  REACT_APP_MESSAGINGSENDERID: '148408185927',
  REACT_APP_APPID: '1:148408185927:web:5075e8b57d4ce09bd22d62',
  REACT_APP_MEASUREMENTID: 'G-YGFFGNWGRJ'
};
